import { render } from "./FileSimple.vue?vue&type=template&id=75c33adc"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FileSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75c33adc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75c33adc', __exports__)) {
    api.reload('75c33adc', __exports__)
  }
  
  module.hot.accept("./FileSimple.vue?vue&type=template&id=75c33adc", () => {
    api.rerender('75c33adc', render)
  })

}


export default __exports__